// window.customElements.define(
//   'sticky-offer-lp',
//   class extends HTMLElement {
//     connectedCallback() {
//       this.initConfig();
//       this.initState();
//       this.initVisibilityHandlers();
//       this.updateVisibility();
//     }

//     disconnectedCallback() {
//       this.removeEventListeners();
//     }

//     initConfig() {
//       this.scrollThreshold = parseFloat(this.dataset.scrollThreshold) || 50;
//       this.footerSelector = this.dataset.footerSelector || '.footer';
//       this.footer = document.querySelector(this.footerSelector);
//     }

//     initState() {
//       this.isVisible = false;
//       this.ticking = false;
//     }

//     initVisibilityHandlers() {
//       this.boundOnScroll = this.onScroll.bind(this);
//       this.boundOnResize = this.onResize.bind(this);

//       window.addEventListener('scroll', this.boundOnScroll, { passive: true });
//       window.addEventListener('resize', this.boundOnResize, { passive: true });
//     }

//     removeEventListeners() {
//       window.removeEventListener('scroll', this.boundOnScroll);
//       window.removeEventListener('resize', this.boundOnResize);
//     }

//     getScrollPercentage() {
//       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
//       if (docHeight === 0) return 0;
//       return (scrollTop / docHeight) * 100;
//     }

//     isFooterInView() {
//       if (!this.footer) {
//         this.footer = document.querySelector(this.footerSelector);
//         if (!this.footer) return false;
//       }

//       const footerRect = this.footer.getBoundingClientRect();
//       const viewportHeight = window.innerHeight;

//       return footerRect.top < viewportHeight && footerRect.bottom > 0;
//     }

//     updateVisibility() {
//       const scrollPercent = this.getScrollPercentage();
//       const footerVisible = this.isFooterInView();

//       if (scrollPercent >= this.scrollThreshold && !footerVisible) {
//         if (!this.isVisible) {
//           this.show();
//         }
//       } else if (footerVisible) {
//         if (this.isVisible) {
//           this.hide();
//         }
//       } else if (scrollPercent < this.scrollThreshold) {
//         if (this.isVisible) {
//           this.hide();
//         }
//       }

//       this.ticking = false;
//     }

//     show() {
//       this.classList.add('is-visible');
//       this.classList.remove('is-hidden');
//       this.isVisible = true;
//     }

//     hide() {
//       this.classList.add('is-hidden');
//       this.isVisible = false;

//       setTimeout(() => {
//         if (this.classList.contains('is-hidden')) {
//           this.classList.remove('is-visible');
//         }
//       }, 300);
//     }

//     onScroll() {
//       if (!this.ticking) {
//         window.requestAnimationFrame(() => this.updateVisibility());
//         this.ticking = true;
//       }
//     }

//     onResize() {
//       if (!this.ticking) {
//         window.requestAnimationFrame(() => this.updateVisibility());
//         this.ticking = true;
//       }
//     }
//   }
// );


window.customElements.define(
  'sticky-offer-lp',
  class extends HTMLElement {
    connectedCallback() {
      this.initConfig();
      this.initState();
      this.initVisibilityHandlers();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    initConfig() {
      this.footerSelector = this.dataset.footerSelector || '.footer';
      this.buyButtonsSelector =
        this.dataset.buyButtonsSelector || '.product-info__buy-buttons';

      this.footer = document.querySelector(this.footerSelector);
      this.buyButtons = document.querySelector(this.buyButtonsSelector);
    }

    initState() {
      this.isVisible = false;
      this.ticking = false;
    }

    initVisibilityHandlers() {
      this.boundOnScroll = this.onScroll.bind(this);
      this.boundOnResize = this.onResize.bind(this);

      window.addEventListener('scroll', this.boundOnScroll, {
        passive: true,
      });
      window.addEventListener('resize', this.boundOnResize, {
        passive: true,
      });
    }

    removeEventListeners() {
      window.removeEventListener('scroll', this.boundOnScroll);
      window.removeEventListener('resize', this.boundOnResize);
    }

    isBuyButtonsPassed() {
      if (!this.buyButtons) {
        this.buyButtons = document.querySelector(this.buyButtonsSelector);
        if (!this.buyButtons) return false;
      }

      const rect = this.buyButtons.getBoundingClientRect();

      // Trigger when buy buttons scroll out of view
      return rect.bottom < 0;
    }

    isFooterInView() {
      if (!this.footer) {
        this.footer = document.querySelector(this.footerSelector);
        if (!this.footer) return false;
      }

      const footerRect = this.footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      return footerRect.top < viewportHeight && footerRect.bottom > 0;
    }

    updateVisibility() {
      const buyButtonsPassed = this.isBuyButtonsPassed();
      const footerVisible = this.isFooterInView();

      if (buyButtonsPassed && !footerVisible) {
        if (!this.isVisible) {
          this.show();
        }
      } else {
        if (this.isVisible) {
          this.hide();
        }
      }

      this.ticking = false;
    }

    show() {
      this.classList.add('is-visible');
      this.classList.remove('is-hidden');
      this.isVisible = true;
    }

    hide() {
      this.classList.add('is-hidden');
      this.isVisible = false;

      setTimeout(() => {
        if (this.classList.contains('is-hidden')) {
          this.classList.remove('is-visible');
        }
      }, 300);
    }

    onScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => this.updateVisibility());
        this.ticking = true;
      }
    }

    onResize() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => this.updateVisibility());
        this.ticking = true;
      }
    }
  }
);